import { render, staticRenderFns } from "./transactionRowItem.vue?vue&type=template&id=3b809fd6&"
import script from "./transactionRowItem.vue?vue&type=script&lang=js&"
export * from "./transactionRowItem.vue?vue&type=script&lang=js&"
import style0 from "./transactionRowItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports